import yup from '~/libs/yup';

export const loginSchema = yup.object().shape({
  login: yup.string().required().label('Usuário'),
  password: yup.string().required().label('Senha'),
});
